<template>
    <v-app>
        <template v-if="!isLogin">
            <v-overlay :value="loading" z-index="1000">
                <v-progress-circular indeterminate size="64" />
            </v-overlay>
            <v-navigation-drawer
                app
                :width="230"
                v-model="drawer"
                color="primary"
                dark
                class="elevation-3"
            >
                <div class="px-4 py-5 white brand-header-white d-flex align-center justify-center">
                    <v-img :src="require('@/assets/logo.png')" max-height="44" contain />
                </div>
                <v-list nav dense class="px-2 py-3">
                    <v-list-item
                        :to="{ name: 'Users' }"
                        v-if="$store.state.auth.admin"
                        active-class="active-nav-item"
                    >
                        <v-list-item-icon>
                            <Users class="nav-icon" :size="22" />
                        </v-list-item-icon>
                        <v-list-item-title>Пользователи</v-list-item-title>
                    </v-list-item>
                    <v-list-item
                        :to="{ name: 'Settings' }"
                        v-if="$store.state.auth.admin"
                        active-class="active-nav-item"
                    >
                        <v-list-item-icon>
                            <Settings class="nav-icon" :size="22" />
                        </v-list-item-icon>
                        <v-list-item-title>Настройки</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="{ name: 'News' }" active-class="active-nav-item">
                        <v-list-item-icon>
                            <Newspaper class="nav-icon" :size="22" />
                        </v-list-item-icon>
                        <v-list-item-title>Новости</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="{ name: 'Comments' }" active-class="active-nav-item">
                        <v-list-item-icon>
                            <MessagesSquare class="nav-icon" :size="22" />
                        </v-list-item-icon>
                        <v-list-item-title>Комментарии к новостям</v-list-item-title>
                    </v-list-item>
                    <v-list-item :to="{ name: 'Tags' }" active-class="active-nav-item">
                        <v-list-item-icon>
                            <Tags class="nav-icon" :size="22" />
                        </v-list-item-icon>
                        <v-list-item-title>Теги новостей</v-list-item-title>
                    </v-list-item>
                     <v-list-item :to="{ name: 'Banners' }" active-class="active-nav-item">
                         <v-list-item-icon>
                             <ImageIcon class="nav-icon" :size="22" />
                         </v-list-item-icon>
                         <v-list-item-title>Баннеры</v-list-item-title>
                     </v-list-item>
                     <v-list-item :to="{ name: 'Ads' }" active-class="active-nav-item">
                         <v-list-item-icon>
                             <Megaphone class="nav-icon" :size="22" />
                         </v-list-item-icon>
                         <v-list-item-title>Объявления</v-list-item-title>
                     </v-list-item>
                     <v-list-item
                         v-if="categoriesFeatureEnabled"
                         :to="{ name: 'Categories' }"
                         active-class="active-nav-item"
                     >
                         <v-list-item-icon>
                             <Shapes class="nav-icon" :size="22" />
                         </v-list-item-icon>
                         <v-list-item-title>Категории объявлений</v-list-item-title>
                     </v-list-item>
                     <v-list-item :to="{ name: 'Videos' }" active-class="active-nav-item">
                         <v-list-item-icon>
                             <Video class="nav-icon" :size="22" />
                         </v-list-item-icon>
                         <v-list-item-title>Видео</v-list-item-title>
                    </v-list-item>
                </v-list>
                <v-divider class="rgba-divider" />
                <v-list nav dense class="px-2 py-2">
                    <v-list-item @click="downloadUsersExcel" active-class="active-nav-item">
                        <v-list-item-icon>
                            <Download class="nav-icon" :size="22" />
                        </v-list-item-icon>
                        <v-list-item-title>Выгрузить список пользователей</v-list-item-title>
                    </v-list-item>
                </v-list>
                <v-divider class="rgba-divider" />
                <v-list nav dense class="px-2 py-2">
                    <v-list-item @click="logout" active-class="active-nav-item">
                        <v-list-item-icon>
                            <LogOut class="nav-icon" :size="22" />
                        </v-list-item-icon>
                        <v-list-item-title>Выход</v-list-item-title>
                    </v-list-item>
                </v-list>
            </v-navigation-drawer>
            <v-app-bar app flat color="white" class="border-bottom-header">
                <v-app-bar-nav-icon
                    @click.stop="drawer = !drawer"
                    color="primary"
                />
                <v-toolbar-title class="primary--text font-weight-bold text-h6 ml-2">
                    {{ $route.meta.title }}
                </v-toolbar-title>
            </v-app-bar>
        </template>

        <v-main>
            <v-container :fill-height="isLogin" fluid :class="isLogin ? 'pa-0' : 'content-container'">
                <router-view />
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import { saveAs } from 'file-saver';
// Иконки меню — Lucide (lucide-vue собран под Vue 2). Импортируем поштучно,
// чтобы в сборку не попал весь набор.
import {
    Users,
    Settings,
    Newspaper,
    MessagesSquare,
    Tags,
    Image as ImageIcon,
    Megaphone,
    Shapes,
    Video,
    Download,
    LogOut,
} from 'lucide-vue';

export default {
    name: "App",

    components: {
        // Имя «Image» брать нельзя: это тег SVG, Vue считает его зарезервированным
        // и компонент с таким именем молча не отрисовывается.
        ImageIcon,
        Users,
        Settings,
        Newspaper,
        MessagesSquare,
        Tags,
        Megaphone,
        Shapes,
        Video,
        Download,
        LogOut,
    },

    data: () => ({
        API_URL: process.env.VUE_APP_API,
        drawer: null,
        loading: false,
        // раздел скрыт по просьбе заказчика, функционал не убран - можно вернуть true
        categoriesFeatureEnabled: false,
    }),

    computed: {
        isLogin() {
            return this.$route.name == "Login";
        },
        isHome() {
            return this.$route.name == "Home";
        },
    },
    methods: {
        async downloadUsersExcel () {
            try {
                let r = await this.$api("/admin/users/excel");
                if (!r.error) {
                    await saveAs(this.API_URL + r.file, "users.xlsx");
                    await this.$api("/admin/users/remove-excel", {
                        method: 'DELETE'
                    });
                }
            } catch (e) {
                this.$error(e.message);
            }
        },
        async logout() {
            this.loading = true;
            await this.$api("/logout");
            this.$store.commit("auth/token", null);
            this.$router.push({ name: "Login" });
            this.drawer = false;
            this.loading = false;
        },
    },
};
</script>

<style lang="scss">
/* Иконки Lucide внутри v-icon: у svg свои width/height, а Vuetify задаёт размер
   шрифтом (small/large/x-large). Привязываем svg к размеру шрифта, чтобы эти
   свойства работали как со старым набором иконок. */
.v-icon svg {
    width: 1em;
    height: 1em;
}

/* Глобальные стили для админки */
.v-application {
    font-family: 'Roboto', sans-serif !important;
    background-color: var(--v-background-base) !important;
    
    a {
        color: var(--v-accent-base) !important;
        text-decoration: none;
        &:hover {
            text-decoration: underline;
        }
    }
}

/* Сайдбар */
.brand-header-white {
    background-color: #ffffff !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.08) !important;
    height: 84px;
}
.v-navigation-drawer {
    /* Отключаем подчеркивание ссылок в меню */
    a, .v-list-item {
        text-decoration: none !important;
        &:hover {
            text-decoration: none !important;
        }
    }
    
    .v-list-item {
        border-radius: 8px !important;
        margin-bottom: 4px !important;
        transition: background-color 0.15s ease;
        
        /* Lucide рисует линией и берёт currentColor, поэтому цвет задаём и ему */
        .v-icon, .nav-icon, .v-list-item__title {
            color: rgba(255, 255, 255, 0.7) !important;
            transition: color 0.15s ease;
        }

        .nav-icon {
            flex: 0 0 auto;
        }

        /* Vuetify отодвигает текст от иконки на 32px — для узкого меню это много. */
        .v-list-item__icon {
            margin-right: 8px !important;
        }
        
        &:hover {
            background-color: rgba(255, 255, 255, 0.05) !important;
            .v-icon, .nav-icon, .v-list-item__title {
                color: #ffffff !important;
            }
        }
        
        &--active, &.active-nav-item {
            background-color: var(--v-accent-base) !important;
            color: #ffffff !important;
            
            .v-icon, .nav-icon, .v-list-item__title {
                color: #ffffff !important;
            }
            
            &:hover {
                background-color: var(--v-accent-base) !important;
            }
        }
    }
}

/* Шапка */
.border-bottom-header {
    border-bottom: 1px solid #e2e8f0 !important;
}

/* Современные плоские карточки */
.v-card {
    border-radius: 12px !important;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05), 0 2px 4px -1px rgba(0, 0, 0, 0.03) !important;
    border: 1px solid #e8edf5 !important;
    
    &.v-card--flat {
        box-shadow: none !important;
        border: none !important;
    }
    
    .v-card__title {
        color: var(--v-primary-base) !important;
        font-weight: 600 !important;
        font-size: 1.25rem !important;
        border-bottom: 1px solid #f1f5f9;
        padding: 16px 24px !important;
    }
    
    .v-card__text {
        padding: 24px !important;
    }
    
    .v-card__actions {
        padding: 12px 24px 24px !important;
    }
}

/*
 * Окно добавления/редактирования новости: Vuetify ограничивает диалог
 * по высоте 90% экрана, здесь поднимаем до 95% — форма длинная.
 * Правило глобальное, а не в News.vue: класс из content-class попадает
 * на элемент, который рисует сам VDialog, и scoped-стили News.vue до него не достают.
 */
.v-dialog.news-edit-dialog:not(.v-dialog--fullscreen) {
    max-height: 95% !important;
}

/* Диалоговые окна */
.v-dialog {
    border-radius: 16px !important;
    box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04) !important;
    overflow-y: visible !important;
    
    .v-card {
        border: none !important;
        border-radius: 16px !important;
        box-shadow: none !important;
        
        .v-card__title {
            background-color: #f8fafc !important;
            border-bottom: 1px solid #e2e8f0 !important;
            padding: 20px 24px !important;
            font-size: 1.35rem !important;
            font-weight: 700 !important;
        }
    }
}

/* Вкладки (v-tabs) */
.v-tabs {
    border-bottom: 1px solid #e2e8f0;
    background-color: #f8fafc !important;
    
    .v-tab {
        text-transform: none !important;
        font-weight: 600 !important;
        letter-spacing: 0.3px !important;
        font-size: 0.95rem !important;
        color: #64748b !important;
        padding: 0 20px !important;
        transition: all 0.2s ease;
        
        &--active {
            color: var(--v-accent-base) !important;
        }
        
        &:hover:not(.v-tab--active) {
            color: var(--v-primary-base) !important;
            background-color: rgba(0, 0, 0, 0.02);
        }
    }
    
    .v-tabs-slider {
        height: 3px !important;
        border-radius: 3px 3px 0 0;
        background-color: var(--v-accent-base) !important;
    }
}

/* Кнопки */
.v-btn {
    border-radius: 8px !important;
    text-transform: none !important; /* Убираем капс */
    font-weight: 500 !important;
    letter-spacing: 0.3px !important;
    box-shadow: none !important;
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
    
    &.v-btn--contained {
        box-shadow: 0 1px 3px rgba(0,0,0,0.1) !important;
        &:hover {
            box-shadow: 0 4px 6px rgba(0,0,0,0.12) !important;
            transform: translateY(-1px);
        }
        &:active {
            transform: translateY(0);
        }
    }
}

/* Кастомные правила для кнопок в v-card__actions диалогов */
.v-card__actions {
    .v-btn--text {
        padding: 0 18px !important;
        height: 38px !important;
        
        /* Кнопка Отмена (обычно синяя текстовая кнопка) */
        &.blue--text, &.error--text, &.grey--text {
            color: #64748b !important;
            background-color: #f1f5f9 !important;
            border: 1px solid #e2e8f0 !important;
            
            &:hover {
                background-color: #e2e8f0 !important;
                color: #334155 !important;
            }
        }
        
        /* Кнопка подтверждения / сохранения */
        &.blue--text:last-child,
        &.primary--text:last-child,
        &.success--text:last-child {
            background-color: var(--v-accent-base) !important;
            color: #ffffff !important;
            border: none !important;
            box-shadow: 0 2px 4px rgba(0, 104, 153, 0.2) !important;
            
            &:hover {
                background-color: #005680 !important;
                color: #ffffff !important;
                box-shadow: 0 4px 6px rgba(0, 104, 153, 0.3) !important;
            }
        }
        
        /* Кнопка удаления */
        &.red--text, &.error--text:last-child {
            background-color: #ef4444 !important;
            color: #ffffff !important;
            border: none !important;
            
            &:hover {
                background-color: #dc2626 !important;
                color: #ffffff !important;
            }
        }
    }
}

/* Таблицы */
.v-data-table {
    border-radius: 12px !important;
    border: 1px solid #e8edf5 !important;
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05) !important;
    
    /* Отступы для кнопок "Добавить" в слоте top таблицы */
    > .v-btn,
    > .v-dialog__activator > .v-btn,
    > div > .v-btn,
    > div > .v-dialog__activator > .v-btn {
        margin: 16px 16px 8px 16px !important;
    }
    
    .v-data-table-header {
        th {
            font-weight: 600 !important;
            color: var(--v-primary-base) !important;
            background-color: #f8fafc !important;
            font-size: 0.82rem !important;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            height: 48px !important;
            border-bottom: 1px solid #e2e8f0 !important;
        }
    }
    
    tbody {
        tr {
            transition: background-color 0.15s ease;
            &:hover {
                background-color: #f8fafc !important;
            }
            td {
                font-size: 0.9rem !important;
                color: #334155 !important;
                height: 52px !important;
                border-bottom: 1px solid #f1f5f9 !important;
            }
        }
    }
    
    /* Адаптивный скролл таблицы на мобильных устройствах */
    .v-data-table__wrapper {
        overflow-x: auto !important;
        -webkit-overflow-scrolling: touch;
    }

    /* На широком экране боковые поля ячеек вдвое меньше стандартных 16px:
       колонок много, и лишний воздух уводил «Действия» за край экрана.
       На узких экранах оставляем как было — там важнее, чтобы не слипалось. */
    @media (min-width: 960px) {
        th,
        td {
            padding: 0 8px !important;
        }

        th:first-child,
        td:first-child {
            padding-left: 12px !important;
        }

        th:last-child,
        td:last-child {
            padding-right: 12px !important;
        }
    }
}

/* Стилизация форм, инпутов и текстовых полей */
.v-input {
    font-size: 0.95rem !important;
    
    .v-input__slot:before {
        border-color: #cbd5e1 !important;
    }
    
    &.v-input--is-focused {
        .v-input__slot:after {
            border-color: var(--v-accent-base) !important;
        }
    }
    
    .v-label {
        font-size: 0.9rem !important;
        color: #64748b !important;
    }
}

/* Округлые поля ввода (outlined) */
.v-text-field--outlined, .v-text-field--solo, .v-select--outlined, .v-textarea--outlined {
    border-radius: 8px !important;
}

/* Чекбоксы */
.v-input--checkbox {
    margin-top: 8px !important;
    
    .v-icon {
        font-size: 22px !important;
    }
    
    &.v-input--is-label-active, &.v-input--is-dirty {
        .v-icon {
            color: var(--v-accent-base) !important;
        }
    }
}

/* Контейнер */
.content-container {
    padding: 24px !important;
    max-width: 1400px !important;
    
    @media (max-width: 600px) {
        padding: 16px 12px !important;
    }
}

.leading-tight {
    line-height: 1.25 !important;
}

/* Адаптивные исправления для форм и сеток */
@media (max-width: 600px) {
    .v-card__title {
        font-size: 1.15rem !important;
        padding: 12px 16px !important;
    }
    .v-card__text {
        padding: 16px !important;
    }
    .v-card__actions {
        padding: 12px 16px 16px !important;
        flex-direction: column-reverse;
        gap: 8px;
        
        .v-btn {
            width: 100% !important;
            margin: 0 !important;
        }
        
        .v-spacer {
            display: none;
        }
    }
    
    /*
     * Вертикальные отступы диалога делаем такими же, как боковые (12px).
     * По умолчанию Vuetify ограничивает диалог max-height: 90%, из-за чего
     * сверху и снизу оставалось по 5% высоты экрана — заметно больше боков.
     */
    .v-dialog {
        margin: 12px !important;
        max-height: calc(100% - 24px) !important;
    }
    
    .v-tabs-items {
        .v-card-text {
            padding: 12px 8px !important;
        }
    }
}
</style>
